module.exports = __webpack_public_path__ + "img/image-04.e0e8ee2e.webp";